interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const start = Math.max(1, Math.min(page - 2, totalPages - 4));
  const pages = Array.from({ length: Math.min(5, totalPages) }, (_, index) => start + index);

  return (
    <nav aria-label="电影列表分页" className="hidden items-center justify-center gap-2 md:flex">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        className={`flex h-9 items-center gap-1 rounded-md border px-3 text-xs transition-colors ${
          page === 1
            ? "cursor-not-allowed border-background-800 text-foreground-600"
            : "border-background-700 text-foreground-300 hover:border-accent-500/60 hover:text-accent-400"
        }`}
      >
        <i className="ri-arrow-left-s-line text-base" />
        上一页
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page ? "page" : undefined}
          className={`h-9 w-9 rounded-md text-xs transition-colors ${
            item === page
              ? "bg-accent-500 font-medium text-background-950"
              : "border border-background-800 text-foreground-300 hover:border-accent-500/60 hover:text-accent-400"
          }`}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className={`flex h-9 items-center gap-1 rounded-md border px-3 text-xs transition-colors ${
          page === totalPages
            ? "cursor-not-allowed border-background-800 text-foreground-600"
            : "border-background-700 text-foreground-300 hover:border-accent-500/60 hover:text-accent-400"
        }`}
      >
        下一页
        <i className="ri-arrow-right-s-line text-base" />
      </button>
    </nav>
  );
}